<template>
    <div class="warp-block">
        <el-dialog  title="编辑工厂类型" :visible.sync="showBlock" :close-on-click-modal="false" width="450px" :before-close="handleClose">
            <el-form :model="formDate" ref="formDate" status-icon :rules="rules" label-width="70px" class="demo-ruleForm">
                <el-form-item  label="工厂类型" prop="name" >
                    <el-input v-model="formDate.name" maxlength="6" placeholder="请输入工厂类型名称" onkeyup='value=value.replace(/^\s*|\s*$/g,"")' autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item  label="菜单状态" prop="enabled">
                    <SelectBlock keyVal="enabled" ref="enabled"  title="" placeholder="请选择菜单状态" size="medium" left="0" right="0" :options="menuListstate" width="380" @getVal="getValue" />
                </el-form-item>
                <el-form-item  label="显示排序" prop="orderNo">
                    <el-input-number v-model="formDate.orderNo" controls-position="right" :min="1" :max="6" onkeyup='value=value.replace(/^\s*|\s*$/g,"")' style="width:340px;"></el-input-number>
                </el-form-item>
                <el-form-item  label="选择目录" prop="orderNo">
                     <div class="block-line">
                        <el-tree  :data="data" :check-strictly="true"  ref="tree" @check-change="handleCheckChange" show-checkbox  node-key="id" :default-checked-keys="formDate.mbIds"  :props="defaultProps">
                            <!-- <span class="custom-tree-node" slot-scope="{ node, data }">
                                <span>{{ getText(node,data) }}</span>
                            </span> -->
                        </el-tree>
                     </div>
                </el-form-item>
                <el-form-item  label="类型描述" prop="remarks">
                    <el-input v-model="formDate.marks" type="textarea" maxlength="100" placeholder="请输入描述内容" onkeyup='value=value.replace(/^\s*|\s*$/g,"")' show-word-limit :autosize="{minRows:3}"  autocomplete="off"></el-input>
                </el-form-item>
                <div class="warp-btn">
                    <el-form-item>
                        <div  class="dialog-footer">
                            <el-button @click="handleClose">取消</el-button>
                            <el-button type="primary" @click="submitForm('formDate')">提交</el-button>
                        </div>
                    </el-form-item>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
  import {url,userApi,operate} from '@/utils/config'
  import {postFun,getFun,putFun} from '@/utils/httpFun'
  import {isEmpty} from '@/utils/util'
  export default{

     data(){
       return{
            rules:{
                name:[{validator:isEmpty, trigger:'blur'}],
            },
            menuListstate:[
                { indexNo: '1', selectName: '启用'}, 
                { indexNo: '0', selectName: '禁用'}
            ],
            showBlock: false,
            defaultProps: {
                children: 'childMBs',
                label: 'name'
            },
            data: [],
            formDate: {
                name: '',
                enabled: "0", //0表示禁用  //1启用
                state:0,      //0表示未删除 1表示已经删除
                marks:"",
                orderNo:1, 
                mbIds:[]  
            },
           
       }
     }, 
     created(){
        this.$store.commit({
         type: "setEmptyText",
         emptyText:"工厂类型名不空为空",
        })
     },
     methods:{
        getText(node,data){
            console.log("测试-",node)
            if(!this.formDate.mbIds.includes(data.id)){
                console.log("测试---------------",node)
                // this.$refs.tree.setCurrentNode(node)
            }
            return node.label;
        },
        //获取工厂端的菜单
        async getFactory(){
          let parms = {
              id:0,                          //0根节点
              subsystemId:3,                 //平台id
              type:"",                       // 1菜单 2 按钮    
          }
          await postFun(operate.MODULETREE,parms,res=>{
              this.data = res.data
          })
        },
        
        //获取选中的值
        getValue(ev){
             this.formDate.enabled = ev.indexNo
        },
        
        //重置输入框信息
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

        //提交
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                        this.addMess()
                    }else{
                        return false;
                }
            });
        },

        //新增BTn
        async addMess(){
            let parms = {
                id:this.formDate.id,
                name:this.formDate.name, 
                enabled:this.formDate.enabled,
                sort:this.formDate.orderNo,
                marks:this.formDate.marks,
                mbIds:this.formDate.mbIds
            }
            parms.operator = this.$store.state.operator
            await putFun(userApi.FACTORYTYPEUPDATE,parms,res=>{
                  this.$parent.getList() 
                  this.showBlock = false  
            })
        },

        //获取选中的值
        handleCheckChange(){
          let res = this.$refs.tree.getCheckedNodes()
            let arrDeptId = []
            let name = []
            res.forEach((item) => {
                arrDeptId.push(item.id)
                name.push(item.name)
            })
            this.formDate.mbIds = arrDeptId
        },

        //开启弹窗
        showMessage(ev){
            
           this.showBlock = true
           this.getFactory()
           this.$nextTick(res=>{
               this.formDate.id = ev.id
               this.formDate.name = ev.name
               this.formDate.orderNo = ev.sort
               this.formDate.enabled = ev.enabled
               this.formDate.marks = ev.marks
               this.formDate.mbIds = []
               this.$refs.enabled.setVal(ev.enabled*1==0 ?"禁用":"启用")
               this.getEmun(ev)
           })
        },

        //编辑工厂类型的回显
        async getEmun(ev){
             await getFun(userApi.FACTORYTYPEHUIXIAN+"/"+ev.id,{},res=>{
                 this.formDate.mbIds = res.data.mbIds
             })
        },
       
        //关闭弹窗
        handleClose() {
            this.formDate.name = '' 
            this.showBlock = false
        }
     }
  }
</script>
<style scoped lang="scss">
    .warp-block{
        ::v-deep .el-input__count{
          background-color: rgba(0, 0, 0, 0);
       }
       .block-line{
            border: 1px solid #DCDFE6;
            border-radius: 4px;
            min-height:110px;
            max-height:300px;
            overflow-y: auto;
            padding:15px;
            box-sizing: border-box;
       }  
    }
   .dialog-footer{
       display: flex;
       justify-content: flex-end;
   }
   .warp-btn{
    .el-form-item {
        margin-bottom:0px!important;
     }
   }
   
</style>